import React, { useState, useEffect } from 'react';
import { fetchAnalytics } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import '../App.css';

function Analytics() {
  const { fetchPartnerName } = useAuth();
  const [metrics, setMetrics] = useState({
    total_voucher: 0,
    total_affiliate:0,
    total_amount: 0,
    total_commission: 0
  });

  useEffect(() => {
    const loadMetrics = async () => {
      try {
        const data = await fetchAnalytics(fetchPartnerName());
        setMetrics(data);
      } catch (error) {
        console.error('Error loading analytics:', error);
      }
    };
    loadMetrics();
  }, [fetchPartnerName]);

  return (
    <div className="main-content">
      <h2>Analytics Dashboard</h2>
      <div className="summary-cards">
        <div className="summary-card">
          <h3>Total Vouchers</h3>
          <p>{metrics.total_voucher.toLocaleString()}</p>
        </div>
        <div className="summary-card">
          <h3>Total Affiliates</h3>
          <p>{metrics.total_affiliate.toLocaleString()}</p>
        </div>
        <div className="summary-card">
          <h3>Total Purchase Amount</h3>
          <p>IDR {metrics.total_amount.toLocaleString()}</p>
        </div>
        <div className="summary-card">
          <h3>Total Commission</h3>
          <p>IDR {metrics.total_commission.toLocaleString()}</p>
        </div>
        </div>
    </div>
  );
}

export default Analytics;